(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    DashboardController.$inject = ['$scope', '$stateParams', '$sce', 'common', 'dataservice', '$timeout'];
    /* @ngInject */
    function DashboardController($scope, $stateParams, $sce, common, dataservice, $timeout) {
        var vm = this;
        vm.title = "Dashboard";
        vm.isLoading = true;
        vm.refresh = refresh;
        vm.onDate = common.getMainState("mainDate");
        vm.ExpirationWarningMsg = "";

        vm.scrollerData = {};
        vm.safeSvg = safeSvg;
        vm.selectedSvg = "";
        vm.selectedSvgId = '';
        vm.selectedCaption = '';
        vm.processFloorPlan = processFloorPlan;
        vm.availabilityStatus = "";
        vm.notNow = false;
        vm.getAvailability = getAvailability;
        vm.activeRoomCodes = [];
        vm.activeRooms = [];
        vm.keyValueRooms = [];
        vm.availabilityStatus = "";
        vm.backToNow = _backToNow;
        vm.selectedCategory = -1;
        vm.floorPlanSelected = floorPlanSelected;
        vm.roomClicked = roomClicked;
        vm.expirationClass = "wred";
        vm.userService = common.userService;
        vm.exchangeSync = exchangeSync;
        vm.alertColor = vm.alertCount > 0 ? 'red' : 'primary';
        

        vm.makeMapTime = function (valueToConvert) {
            var asDate = moment.unix(valueToConvert);
            return asDate.format("ddd, hh:mm A");
        }
        vm.mapTimeChanged = mapTimeChanged;

        activate();

        function activate() {
            common.notifier.subscribe(common.config.events.mainDateChange, $scope, dateChanged);

            var dateAsMoment = moment(vm.onDate);
            vm.scrollerData.mapTimeMin = dateAsMoment.startOf('day').unix();;
            vm.scrollerData.mapTime = moment(vm.onDate).unix();
            vm.scrollerData.mapTimeMax = dateAsMoment.add(1, 'd').unix();


            if (common.userService.userType() > 0) {
                var activeUntil = moment(common.userService.activeUntilUtc(), "MM/DD/YYYY hh:mm:ss a")
                var now = moment();
                var diff = activeUntil.diff(now, 'days');

                var daysTilExpiration = activeUntil.diff(now, 'days');

                if (daysTilExpiration < 45 && daysTilExpiration > 15) {
                    vm.ExpirationWarningMsg = "Your subscription to 7 Point OPs is up for renewal on " + activeUntil.format("MM/DD/YYYY");
                    vm.ExpirationTitleMsg = "Thanks for being a subscriber"
                    vm.expirationClass = "wdarkgreen";
                }

                if (daysTilExpiration < 15) {
                    vm.ExpirationTitleMsg = "Thanks for being a subscriber";
                    vm.ExpirationWarningMsg = "Your subscription to 7 Point Ops is expiring on " + now.add(diff, 'days').format("MM/DD/YYYY");
                    vm.expirationClass = "wred";
                }
            }

            //var promises = [getItems(), getFloorPlans(), getLookups()];
            var promises = [loadData()]
            return common.$q.all(promises).then(function () {
                //this fixes where the time is in slider
                $scope.$broadcast("refreshSlider");
                common.logger.info('Activated ' + vm.title + ' View');
                _setClock();
                vm.isLoading = false;
            }, function (error) { });
        }

        var _availabilityTimer = null;
        var _backToNowTimer = null;
        var _clockTimer = null;

        function _setClock() {
            var secondsUntilNextMin = moment().seconds();
            var wait = 60 - secondsUntilNextMin;
            _clockTimer = $timeout(_tick, wait * 1000);
        }

        function roomClicked(room) {
        }

        function _backToNow() {
            vm.notNow = false;
            $timeout.cancel(_availabilityTimer);
            vm.scrollerData.mapTime = moment(vm.onDate).unix();
            _setClock();
            vm.getAvailability();
        }

        function _tick() {
            var newDate = moment(vm.onDate);
            var newTime = moment();
            var newDateTime = moment(common.buildDateTime(newDate.toDate(), newTime.toDate())).unix();


            //we just ticked into tomorrow
            if (newDateTime > vm.scrollerData.mapTimeMax) {
                vm.scrollerData.mapTimeMin = moment(vm.onDate).startOf('day').unix();
                vm.scrollerData.mapTimeMax = moment(vm.onDate).startOf('day').add(1, 'd').unix();
            }
            vm.scrollerData.mapTime = newDateTime;

            _clockTimer = $timeout(_tick, 60000);
        }

        function safeSvg(svg) {
            return $sce.trustAsHtml(svg);
        }

        function exchangeSync() {
            dataservice.getItem("api/StorageQueue/ExchangeSync").then(function (response) {
                console.log(response);
            });
         }


        function getAvailability() {
            $timeout.cancel(_availabilityTimer);
            vm.availabilityStatus = "Loading availability";
            var m = vm.scrollerData.mapTime;

            var availabilityDate = new Date(m * 1000);

            var availDto = {
                GmtDateTime: availabilityDate,
                Rooms: vm.keyValueRooms
            };
            if (availDto.Rooms.length > 0) {
                if (vm.selectedCategory === -1) {

                    dataservice.query("api/FloorPlans/AvailabilityForRooms", availDto).then(function (response) {
                        var availablityData = response.data.RoomAvailability;
                        if (availablityData) {
                            var roomNodes = $("#floorPlanHolder").find(".room");

                            for (var i = 0; i < availablityData.length; i++) {
                                var roomElement = $("#floorPlanHolder").find(".room[data-roomcode='" + availablityData[i].RoomCode + "']");
                                if (roomElement) {
                                    var style = roomElement.attr("style");
                                    var reserved = availablityData[i].IsReserved;
                                    //var occupied = loop[i].IsOccupied;
                                    //var isSensorControlledSpace = loop[i].IsSensorControlledSpace;

                                    var fill;
                                    if (reserved === true) {
                                        fill = "#ff0000";

                                    }
                                    else {
                                        fill = "#00ff0a";
                                    }
                                    roomElement.css({ fill: fill });
                                }
                            }
                        }
                    }, function (error) { }).finally(function () {

                        _availabilityTimer = $timeout(vm.getAvailability, 300000);
                        vm.availabilityStatus = "";
                    });
                }
                else {
                    dataservice.query("api/FloorPlans/ServiceAvailability", availDto).then(function (response) {
                        var availablityData = response.data.ServicesInUse;
                        if (availablityData) {
                            var roomNodes = $("#floorPlanHolder").find(".room");

                            for (var i = 0; i < availablityData.length; i++) {
                                var onItem = availablityData[i];

                                var roomElement = $("#floorPlanHolder").find(".room[data-roomcode='" + onItem.RoomCode + "']");
                                if (roomElement) {
                                    var style = roomElement.attr("style");
                                    var hasCategory = false;
                                    if (onItem.CategoriesInUse.length > 0) {
                                        for (var j = 0; j < onItem.CategoriesInUse.length; j++) {
                                            if (onItem.CategoriesInUse[j] === vm.selectedCategory) {
                                                hasCategory = true;
                                            }
                                        }
                                    }

                                    var fill;
                                    if (hasCategory === true) {
                                        fill = "#ff0000";
                                    }
                                    else {
                                        fill = "#4198f4";
                                    }
                                    roomElement.css({ fill: fill });
                                }
                            }
                        }
                    }, function (error) { }).finally(function () {

                        _availabilityTimer = $timeout(vm.getAvailability, 300000);
                        vm.availabilityStatus = "";
                    });

                }

            }
            else {
                vm.availabilityStatus = "";
            }
        }

        $scope.$on("$destroy", function () {
            $timeout.cancel(_availabilityTimer);
            $timeout.cancel(_clockTimer);
            $timeout.cancel(_backToNowTimer);
        });

        function processFloorPlan() {

            vm.activeRoomCodes = [];
            vm.activeRooms = [];
            vm.keyValueRooms = [];
            $("#floorPlanHolder").find('.room').each(function (i, obj) {
                var $obj = $(obj);
                var roomCode = $obj.attr("data-roomcode");
                $obj.click(_roomClick);
                vm.activeRoomCodes.push(roomCode);
            });

            dataservice.query("api/FloorPlans/RoomsByCode", vm.activeRoomCodes).then(function (response) {
                vm.activeRooms = response.data;

                for (var i = 0; i < vm.activeRooms.length; i++) {
                    vm.keyValueRooms.push({ "ID": vm.activeRooms[i].ID, "Value": vm.activeRooms[i].Code });
                }
                getAvailability();
            }, function (error) { });

            // var svgId = $("#floorPlanHolder").find("svg").attr("id");
            //svgPanZoom("#" + svgId, { zoomEnabled: true, controlIconsEnaable: true, fit: true, center: true });
        }

        function _roomClick() {
            var roomNode = $(this);
            var roomCode = roomNode.attr("data-roomcode");
            if (roomCode) {
                for (var j = 0; j < vm.keyValueRooms.length; j++) {
                    if (vm.keyValueRooms[j].Value == roomCode) {
                        var roomId = vm.keyValueRooms[j].ID;
                        var m = vm.scrollerData.mapTime;
                        var availabilityDate = new Date(m * 1000);

                        var availDto = {
                            GmtDate: availabilityDate,
                            RoomId: roomId
                        };
                        //  inProgressDiag.display(availDto).then(function (response) { }, function () { });
                    }
                }
            }

        }

        function mapTimeChanged() {
            vm.notNow = true;
            $timeout.cancel(_availabilityTimer);

            $timeout.cancel(_clockTimer);
            $timeout.cancel(_backToNowTimer);
            _availabilityTimer = $timeout(vm.getAvailability, 1000);

            _backToNowTimer = $timeout(_backToNow, 10000);
            vm.availabilityStatus = "Stop to load";
        }

        function _setMapTimerDates() {
            $timeout.cancel(_availabilityTimer);
            $timeout.cancel(_clockTimer);
            $timeout.cancel(_backToNowTimer);

            var dateAsMoment = moment(vm.onDate);
            vm.scrollerData.mapTimeMin = dateAsMoment.startOf('day').unix();;
            vm.scrollerData.mapTime = moment(vm.onDate).unix();
            vm.scrollerData.mapTimeMax = dateAsMoment.add(1, 'd').unix();

            _availabilityTimer = $timeout(vm.getAvailability, 1000);
        }

        function dateChanged(eventName, newDate) {
            vm.onDate = newDate;
            getItems();

            _setMapTimerDates();

        }

        function loadData() {
            var m = moment(vm.onDate);
            var t = new Date();
            var d = m.toDate();
            var q = moment(new Date(d.getFullYear(), d.getMonth(), d.getDate(), t.getHours(), t.getMinutes(), 0, 0));

            return dataservice.getItems('api/Dashboard/Load?localDate=' + q.toISOString() + "&localIsoDateOnly=" + q.format("YYYY-MM-DD"))
                .then(function (response) {
                    var data = response.data;
                    vm.categories = data.Categories;
                    vm.floorPlans = data.FloorPlans;
                    if (vm.floorPlans && vm.floorPlans.length > 0) {
                        floorPlanSelected(vm.floorPlans[0]);
                    }
                    var countModel = data.CountData;
                    vm.alertCount = countModel.AlertCount.ActiveCount;
                    vm.taskCount = countModel.TaskCount.ActiveCount;
                    common.notifier.notify(common.config.events.refreshCounts, { alertsCount: vm.alertCount, tasksCount: vm.taskCount });



                }, function (error) { });
        }

        function getItems() {
            var m = moment(vm.onDate);

            return dataservice.getCounts(m).then(function (response) {
                var countModel = response.data;
                vm.alertCount = countModel.AlertCount.ActiveCount;
                vm.taskCount = countModel.TaskCount.ActiveCount;
                common.notifier.notify(common.config.events.refreshCounts, { alertsCount: vm.alertCount, tasksCount: vm.taskCount });
            }, function (error) { });
        }

        function getLookups() {
            return dataservice.getItems('api/FloorPlans/GetCategories').then(function (response) {
                vm.categories = response.data.Categories;
            }, function (error) { });
        }

        function getFloorPlans() {
            return dataservice.getItems('api/FloorPlans').then(function (response) {
                vm.floorPlans = response.data;
                if (vm.floorPlans && vm.floorPlans.length > 0) {
                    floorPlanSelected(vm.floorPlans[0]);
                }
                return vm.floorPlans;
            }, function (error) { });
        }

        function floorPlanSelected(floorPlan) {
            vm.selectedSvg = floorPlan.SvgData;
            vm.selectedSvgId = floorPlan.ID;
            vm.selectedCaption = floorPlan.Caption;
            $timeout(processFloorPlan, 0);
        }

        function refresh() {
            getItems();
        }
    }
})();
